import { css, styled } from "styled-components";
import { cssSpacing, surfaceColorMap } from "../../util/styles.js";
import type { BackgroundColor, MobileColumns } from "../../types/theme.js";

type ImageSize = "small" | "center" | "full";

export const TopText = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: ${cssSpacing("l")};
`;

export const Grid = styled.div<{
  $columns: number;
  $mobileColumns: MobileColumns;
}>`
  display: grid;
  grid-template-columns: repeat(${(p) => p.$mobileColumns}, minmax(0, 1fr));
  gap: ${cssSpacing("s")};

  @media (min-width: 960px) {
    grid-template-columns: repeat(${(p) => p.$columns || 3}, minmax(0, 1fr));
  }
`;

const cardBase = ($imageSize: ImageSize) => css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${cssSpacing("s")};
  min-width: 0;
  overflow: hidden;
  padding: ${$imageSize === "full" ? cssSpacing(0, 0, "m") : cssSpacing("s")};

  h4 {
    margin-bottom: ${cssSpacing("s")};
  }

  > img {
    max-width: 100%;
    ${$imageSize === "full" && "width: 100%; height: 180px; object-fit: cover;"}
    ${$imageSize === "center" && "height: 90px; width: auto; object-fit: cover; margin: 0 auto;"}
    ${$imageSize === "small" && "height: 90px; width: auto; object-fit: cover;"}
  }

  .rich-text {
    align-self: stretch;
    ${$imageSize === "full" && css`padding: ${cssSpacing("s", "m")};`}
  }

  > :last-child {
    flex-direction: column;
    align-items: center;
  }
`;

const surfaceCss = (bg: BackgroundColor) => css`
  background-color: ${surfaceColorMap[bg]};
  color: ${bg === "surface3" ? "#fff" : "var(--swatch2)"};
  svg path {
    fill: currentColor;
    stroke: currentColor;
  }
`;

const defaultCardCss = css`
  background-color: var(--cardgrid-card-background);
  color: var(--cardgrid-card-text-color);
`;

export const Card = styled.div<{ $bg?: BackgroundColor; $imageSize: ImageSize }>`
  ${(p) => (p.$bg ? surfaceCss(p.$bg) : defaultCardCss)}
  ${({ $imageSize }) => cardBase($imageSize)}
  border-radius: ${(p) => p.theme.borderRadius};
`;

export const CardLink = styled.a<{ $bg?: BackgroundColor; $imageSize: ImageSize }>`
  ${(p) => (p.$bg ? surfaceCss(p.$bg) : defaultCardCss)}
  ${({ $imageSize }) => cardBase($imageSize)}
  border-radius: ${(p) => p.theme.borderRadius};
  text-decoration: none;
  transition: all 0.2s ease-in-out;

  &:hover {
    box-shadow: 0 0 3px rgba(24, 24, 24, 0.5);
    transform: scale(1.01);
  }
`;
